
import { computed, ComputedRef, ref } from "@vue/runtime-core";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import PillModal from "../components/Stories/Stories.vue";
import school from "../components/application/School.vue";
import course from "../components/application/Course.vue";
import {
  ContentComment,
  Course,
  CourseProgressList,
  CourseTrack,
  CourseTrackMandatory,
  FilterCourse,
  Interest,
  School,
  User
} from "../../../domain/entities/entities";
import { Pill, PillList } from "../../../domain/entities/pill";
import { onBeforeMount, onMounted, Ref, watch } from "vue";
import OnboardingModal from "../components/application/onboarding/OnboardingBox.vue";
import router from "../../../src/routes";
import Steps from "../components/application/onboarding/Steps.vue";
import {
  cloneObject,
  dispatchErrorBox,
  isCirculoTemplate,
  isDecolaTemplate,
  scrollToTop,
  toLocaleDateTime
} from "../components/mixins";
import { RepositoryException } from "../../../domain/exceptions/exceptions";
import Event from "../components/application/Event.vue";
import { useStore } from "vuex";
import { EventCourse } from "../../../domain/entities/courseEvent/courseEvent";
import PaginationDefault from "../components/application/shop/PaginationDefault.vue";
import SelectBox from "../components/application/inputs/SelectBox.vue";
import { useRoute } from "vue-router";
import {
  removeQuery,
  updateQueries,
  updateQuery
} from "../../repository/utils/routing_utils";
import IntroductoryContentModal from "../components/application/ModalIntroductoryContent.vue";
import CommentModal from "../components/application/DashboardComments/CommentsModal.vue";
import Comment from "../components/application/DashboardComments/Comment.vue";
import ContentFallback from "../components/application/moldure/ContentFallback.vue";
import ProgressBar from "../components/application/ProgressBar.vue";
import OngoingCourse from "../components/application/OngoingCourse.vue";
import NewCourse from "../components/application/NewCourse.vue";
import { dispatchError } from "../utils/error_handling";
import { wrapLoading } from "../utils/wrap_loading";
import VueMultiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import PillComponent from "../components/Stories/Pill.vue";
import PillLoader from "../components/Stories/PillLoader.vue";
import { Content } from "./content/helpers";
import { removeQueries } from "../utils/routing_utils";
import InfoIcon from "./information/InfoIcon.vue";
import InfoPanel from "./information/InfoPanel.vue";
import BackToTopButton from "./information/BackToTopButton.vue";
import InterestSection from "../components/application/interest/InterestSection.vue";
import MandatoryCourseTrack from "../components/application/MandatoryCourseTrack.vue";
import { getOrderFromURL } from "../utils/order_utils";
import { Order } from "../../../domain/entities/order";
import pill from "../components/Stories/Pill.vue";
import { search } from "../components/application/data-table/table-order-utils";

export default {
  methods: { search },
  computed: {
    pill() {
      return pill;
    }
  },
  components: {
    InterestSection,
    MandatoryCourseTrack,
    BackToTopButton,
    PillLoader,
    NewCourse,
    OngoingCourse,
    ProgressBar,
    ContentFallback,
    Comment,
    CommentModal,
    Event,
    Steps,
    OnboardingModal,
    Carousel,
    Slide,
    PillComponent,
    PillModal,
    school,
    course,
    CourseTrack,
    Navigation,
    PaginationDefault,
    SelectBox,
    IntroductoryContentModal,
    VueMultiselect,
    InfoIcon,
    InfoPanel
  },

  setup() {
    const store = useStore();
    const route = useRoute();

    const openModalIntroductoryContent: Ref<boolean> = ref(false);

    const introductoryContent: Ref<Content | undefined> = ref();

    const messages = [
      "Como você gostaria de ser chamado?",
      "Me conte um pouco mais sobre você!",
      "Temos muitas novidades a explorar e contamos com você para essa missão.",
      "Mas não se preocupe, estaremos te acompanhando e apoiando no que for preciso!",
      "Antes de levá-lo para central de aprendizagem, precisamos de algumas informações para lhe auxiliar nessa jornada.",
      "Selecione até 5 interesses para que possamos preparar o seu caminho para o sucesso.",
      "Estamos quase lá, só falta adicionar uma foto para seu perfil.",
      "Tudo pronto para seu desenvolvimento."
    ];

    const steps = ref(8);

    const user = ref<User>(new User());
    const userInterests = ref<Array<number>>(Array<number>());
    const interests: Ref<Interest[]> = ref(new Array<Interest>());
    const currentStep = ref(1);
    /**
     * return all incompletePills.
     */
    const incompletePills: ComputedRef<Pill[]> = computed(
      () => store.getters["pill_module/pillList"]?.pills || []
    );

    const schools: ComputedRef<Array<School>> = computed(() => {
      return store.getters["categories_module/schools"] || [];
    });

    const redoingOnBoarding = computed(() => {
      return store.getters["userProfile_module/redoOnBoarding"];
    });

    const showOnboarding = (): boolean | undefined => {
      if (isCirculoTemplate()) return;
      if (
        (user.value.name && user.value.isFirstLogin) ||
        (redoingOnBoarding.value && currentStep.value <= steps.value)
      ) {
        disableBodyOverflow();
        return true;
      }
    };

    /** Returns the list of registered events. */
    const eventCourses: ComputedRef<EventCourse[]> = computed(() => {
      return store.getters["event_module/eventCourses"];
    });

    const courses: ComputedRef<Course[]> = computed(
      () => store.getters["course_module/courses"]
    );

    const coursesPages: ComputedRef<number> = computed(
      () => store.getters["course_module/coursesPages"]
    );

    const currentFilter: ComputedRef<FilterCourse> = computed(() => {
      return store.getters["course_module/currentFilter"];
    });

    const openPill = ref(false);

    const startPill = ref(0);

    const completedPills: Ref<Pill[]> = ref([]);

    const schoolFilterIsActive: Ref<boolean> = ref(false);

    const isSelectBoxVisible: Ref<boolean> = ref(false);

    const searchTraining = ref(String(route.query.search || ""));

    let searchTimeout: ReturnType<typeof setTimeout>;

    const showPills: Ref<boolean> = ref(false);

    const schoolIDs: Ref<number[]> = ref([]);

    const widthSelectCourseTracks: Ref<string> = ref("25%");

    const courseTracksBySchool: Ref<CourseTrack[]> = ref([]);

    const courseTracks: Ref<CourseTrack[]> = ref([]);
    const filteredCourseTracks: Ref<CourseTrack[]> = ref([]);

    const pillList: Ref<PillList> = ref(new PillList());

    const courseProgressList: Ref<CourseProgressList> = ref(
      new CourseProgressList()
    );

    const selectedCourseTracks: Ref<Array<CourseTrack>> = ref(
      Array<CourseTrack>()
    );

    const isInfoPanelVisible = ref(false);

    const toggleInfoPanel = () => {
      isInfoPanelVisible.value = !isInfoPanelVisible.value;

      if (isInfoPanelVisible.value) {
        disableBodyOverflow();
      } else {
        enableBodyOverflow();
      }
    };

    const informationsExist = computed(() => {
      const informations = store.getters["information_module/informations"];
      return informations && informations.length > 0;
    });

    const fetchInformations = async () => {
      try {
        await store.dispatch("information_module/list");
      } catch (e) {
        await dispatchErrorBox("Ocorreu um erro ao carregar as informações.");
      }
    };
    const selectedSchoolBox: Ref<School[]> = ref([]);

    const pillSettings = {
      itemsToShow: 1,
      itemsToScroll: 1,
      transition: 800
    };

    const pillInFocusIndex = ref(0);

    const pillBreakpoints = {
      280: {
        itemsToShow: 2,
        itemsToScroll: 2,
        snapAlign: "start"
      },
      390: {
        itemsToShow: 3,
        itemsToScroll: 3,
        snapAlign: "start"
      },
      515: {
        itemsToShow: 4,
        itemsToScroll: 4,
        snapAlign: "start"
      },
      620: {
        itemsToShow: 5,
        itemsToScroll: 5,
        snapAlign: "start"
      },
      740: {
        itemsToShow: 6,
        itemsToScroll: 6,
        snapAlign: "start"
      },
      860: {
        itemsToShow: 7,
        itemsToScroll: 7,
        snapAlign: "start"
      },
      960: {
        itemsToShow: 8,
        itemsToScroll: 8,
        snapAlign: "start"
      },
      1060: {
        itemsToShow: 10,
        itemsToScroll: 10,
        snapAlign: "start"
      }
    };

    /** Event's settings controls the initial state of the event's carousel. */
    const eventsSettings = {
      itemsToShow: 1,
      transition: 800
    };

    const eventInFocusIndex: Ref<number | undefined> = ref();

    /** Event's breakpoints controls the events sliders responsiveness. */
    const eventsBreakpoints = {
      290: {
        itemsToShow: 1.2,
        itemsToScroll: 1
      },
      320: {
        itemsToShow: 1.3,
        itemsToScroll: 1
      },
      380: {
        itemsToShow: 1.7,
        itemsToScroll: 1
      },
      440: {
        itemsToShow: 1.9,
        itemsToScroll: 2
      },
      510: {
        itemsToShow: 2.2,
        itemsToScroll: 3
      },
      550: {
        itemsToShow: 2.4,
        itemsToScroll: 3
      },
      590: {
        itemsToShow: 2.6,
        itemsToScroll: 3
      },
      690: {
        itemsToShow: 3,
        itemsToScroll: 3
      },
      790: {
        itemsToShow: 3.45,
        itemsToScroll: 3
      },
      860: {
        itemsToShow: 3.75
      },
      950: {
        itemsToShow: 4,
        itemsToScroll: 4
      },
      1020: {
        itemsToShow: 4.4
      },
      1180: {
        itemsToShow: 5,
        itemsToScroll: 4
      }
    };

    const ongoingCourseSettings = {
      itemsToShow: 4,
      itemsToScroll: 4,
      snapAlign: "start",
      transition: 800,
      wrapAround: false
    };

    const ongoingCourseBreakpoints = {
      250: { itemsToShow: 1, itemsToScroll: 1 },
      450: { itemsToShow: 2, itemsToScroll: 2 },
      640: { itemsToShow: 3, itemsToScroll: 2 },
      850: { itemsToShow: 3, itemsToScroll: 2 },
      930: { itemsToShow: 4, itemsToScroll: 2 }
    };

    /** Todo: document this explaining where and how it's gonna be used. */
    const recommendedSettings = {
      itemsToShow: 1,
      transition: 800
    };

    /** Todo: explain what the heck is this. */
    const recommendedBreakpoints = {
      320: {
        itemsToShow: 1.2,
        itemsToScroll: 1
      },
      350: {
        itemsToShow: 1.3,
        itemsToScroll: 1
      },
      370: {
        itemsToShow: 1.4,
        itemsToScroll: 1
      },
      390: {
        itemsToShow: 1.5,
        itemsToScroll: 1
      },
      400: {
        itemsToShow: 1.6,
        itemsToScroll: 1
      },
      440: {
        itemsToShow: 1.7,
        itemsToScroll: 1
      },
      470: {
        itemsToShow: 1.8,
        itemsToScroll: 1
      },
      510: {
        itemsToShow: 2,
        itemsToScroll: 1
      },
      540: {
        itemsToShow: 2.2,
        itemsToScroll: 1
      },
      580: {
        itemsToShow: 2.4,
        itemsToScroll: 1
      },
      640: {
        itemsToShow: 2.6,
        itemsToScroll: 1
      },
      690: {
        itemsToShow: 2.9,
        itemsToScroll: 1
      },
      730: {
        itemsToShow: 3,
        itemsToScroll: 2
      },
      760: {
        itemsToShow: 3.3,
        itemsToScroll: 2
      },
      850: {
        itemsToShow: 3.6,
        itemsToScroll: 2
      },
      930: {
        itemsToShow: 4,
        itemsToScroll: 3
      },
      1014: {
        itemsToShow: 4.5,
        itemsToScroll: 2
      },
      1080: {
        itemsToShow: 4.6,
        itemsToScroll: 3
      },
      1170: {
        itemsToShow: 4.8,
        itemsToScroll: 4
      }
    };

    const newCourseSettings = {
      itemsToShow: 1,
      transition: 800
    };

    const newCourseBreakpoints = {
      230: {
        itemsToShow: 1,
        itemsToScroll: 1
      },
      280: {
        itemsToShow: 1.3,
        itemsToScroll: 1
      },
      320: {
        itemsToShow: 1.5,
        itemsToScroll: 1
      },

      350: {
        itemsToShow: 1.7,
        itemsToScroll: 1
      },

      370: {
        itemsToShow: 1.8,
        itemsToScroll: 1
      },
      410: {
        itemsToShow: 2,
        itemsToScroll: 1
      },
      450: {
        itemsToShow: 2.2,
        itemsToScroll: 1
      },
      490: {
        itemsToShow: 2.4,
        itemsToScroll: 1
      },
      530: {
        itemsToShow: 2.6,
        itemsToScroll: 1
      },
      560: {
        itemsToShow: 2.8,
        itemsToScroll: 1
      },
      615: {
        itemsToShow: 3,
        itemsToScroll: 1
      },
      650: {
        itemsToShow: 3.2,
        itemsToScroll: 1
      },
      710: {
        itemsToShow: 3.5,
        itemsToScroll: 1
      },
      800: {
        itemsToShow: 4,
        itemsToScroll: 1
      },
      910: {
        itemsToShow: 4.5,
        itemsToScroll: 1
      },
      1020: {
        itemsToShow: 5,
        itemsToScroll: 1
      },
      1080: {
        itemsToShow: 5.5,
        itemsToScroll: 1
      },
      1180: {
        itemsToShow: 6,
        itemsToScroll: 1
      }
    };

    /** Returns all the courses of the user filtered based on the query param 'filter'. */
    const coursesInProgress: ComputedRef<Course[]> = computed(
      () => store.getters["userProfile_module/courseProgressList"].courses
    );

    const newsCourses: ComputedRef<Course[]> = computed(() => {
      return store.getters["course_module/newCourses"] || [];
    });

    const userInformation: ComputedRef<User> = computed(() => {
      return store.getters["userProfile_module/user"];
    });

    const mandatoryCourseTrack: ComputedRef<CourseTrack[]> = computed(
      () => store.getters["course_track_module/requiredCourseTrack"]
    );

    const mandatoryCourseTrackTrainings: ComputedRef<CourseTrackMandatory> = computed(
      () => store.getters["course_track_module/courseTrackMandatory"]
    );

    onBeforeMount(async () => {
      try {
        scrollToTop();
        setSelectBoxVisibility();
        setWidthSelectedBoxCourseTrack();
        enableBodyOverflow();

        await removeQueries(router, ["pageDefault", "courseID"]);
        await wrapLoading(async () => {
          await loadInformation();
          await loadCoursesInProgress(0);
          await loadCourseTracks();
          if (!route.query.schools || !route.query.courseTracks) {
            courseTracks.value =
              store.getters["categories_module/courseTracks"];
          }

          if (route.query.schools) {
            getSchoolRouteIDs();
            checkSelectedBoxSchoolsByRouteIDS();
            await filterCourseTracksBySchools();
          }

          if (route.query.courseTracks) {
            getCourseTrackRouteIDs();
            checkSelectedBoxCourseTrackByRouteIDS();
          }

          await loadCourse(currentFilter.value);
          setPillsCarouselJustifyContent();
        });

        pillList.value = store.getters["pill_module/pillList"];

        courseProgressList.value =
          store.getters["userProfile_module/courseProgressList"];

        /** todo: Temporary removal of the news courses section */
        /** await loadNewsCourses(); */
      } catch (e) {
        await dispatchError(e);
      }
    });

    onMounted(() => {
      showPills.value = true;
    });

    watch(
      () => route.query,
      async (newQuery, oldQuery) => {
        if (route.name === "dashboard" || route.name === "onboarding") {
          try {
            if (route.query.schools) {
              getSchoolRouteIDs();
              await filterCourseTracksBySchools();

              const selectedCourseTrackIDs = selectedCourseTracks.value.map(
                (courseTrack: CourseTrack) => courseTrack.id
              );
              const courseTrackIDs = courseTracks.value.map(
                (courseTrack: CourseTrack) => courseTrack.id
              );

              for (const selectedCourseTrackID of selectedCourseTrackIDs) {
                if (!courseTrackIDs.includes(selectedCourseTrackID)) {
                  const index = selectedCourseTrackIDs.indexOf(
                    selectedCourseTrackID
                  );
                  if (index !== -1) {
                    selectedCourseTracks.value.splice(index, 1);
                    selectedCourseTrackIDs.splice(index, 1);
                  }
                } else {
                  currentFilter.value.courseTracks.push(selectedCourseTrackID);
                }
              }

              currentFilter.value.courseTracks = selectedCourseTracks.value.map(
                (courseTrack: CourseTrack) => courseTrack.id
              );
            }

            const exitedFromCommentsModal =
              oldQuery.courseID && oldQuery.pageDefault;

            if (
              newQuery.page &&
              !newQuery.pageDefault &&
              !newQuery.courseID &&
              !exitedFromCommentsModal
            ) {
              await wrapLoading(async () => {
                await loadCourse(currentFilter.value);
              });
            }

            if (route.query.pageDefault && route.query.courseID) {
              await loadContentCommentsById(
                parseInt(route.query.courseID.toString())
              );
            }
          } catch (e) {
            await dispatchError(e);
          }
        }
      }
    );

    watch(
      () => route.name,
      async () => {
        if (route.name !== "dashboard") {
          await removeQuery(router, "page");
        }
      }
    );

    watch(
      () => route.query.page,
      async () => {
        if (!route.query.schools && !route.query.courseTracks) {
          await updateQueries(router, {
            page: String(route.query.page)
          });
        }

        if (route.query.courseTracks) {
          await updateQueries(router, {
            page: String(route.query.page),
            courseTracks: String(currentFilter.value.courseTracks)
          });
        }
        if (route.query.schools) {
          await updateQueries(router, {
            page: String(route.query.page),
            schools: String(currentFilter.value.schools)
          });
        }
        if (route.query.schools && route.query.courseTracks) {
          await updateQueries(router, {
            page: String(route.query.page),
            schools: String(currentFilter.value.schools),
            courseTracks: String(currentFilter.value.courseTracks)
          });
        }
      }
    );

    watch(
      () => selectedSchoolBox.value,
      async () => {
        const schoolIDs = selectedSchoolBox.value.map(
          (school: School) => school.id
        );
        currentFilter.value.schools = schoolIDs;
        await updateQuery(router, "schools", String(schoolIDs));
      }
    );

    // Updates the course list when the selected tracks change.
    watch(
      () => selectedCourseTracks.value,
      async () => {
        const courseTrackIDs = selectedCourseTracks.value.map(
          courseTrack => courseTrack.id
        );
        currentFilter.value.courseTracks = courseTrackIDs;
        await updateQueries(router, {
          courseTracks: String(courseTrackIDs),
          page: "1"
        });
      }
    );

    watch(
      () => currentFilter.value.courseTracks,
      async () => {
        if (currentFilter.value.courseTracks.length <= 0) {
          await removeQuery(router, "courseTracks");
        } else {
          await updateQueries(router, {
            courseTracks: String(currentFilter.value.courseTracks),
            page: "1"
          });
        }
      }
    );

    watch(searchTraining, value => {
      clearTimeout(searchTimeout);

      searchTimeout = setTimeout(() => {
        updateQueries(router, {
          search: value.trim(),
          page: "1"
        });
      }, 500);
    });

    const loadNewsCourses = async (): Promise<void> => {
      try {
        await store.dispatch("course_module/loadNewsCourses");
      } catch (e) {
        await dispatchError(e);
      }
    };

    /** Loads all the courses in which the user has an enrollment (including the finished ones). */
    const loadCoursesInProgress = async (index: number): Promise<void> => {
      try {
        await store.dispatch("userProfile_module/loadUserCoursesInProgress", {
          index: index
        });
        courseProgressList.value =
          store.getters["userProfile_module/courseProgressList"];
      } catch (e) {
        await dispatchError(e);
      }
    };

    const handleSlideCoursesInProgress = async () => {
      if (!courseProgressList.value.hasMore) return;
      await loadCoursesInProgress(courseProgressList.value.courses.length);
    };

    const getSchoolRouteIDs = (): void => {
      const ids = (route.query.schools as string).split(",");
      currentFilter.value.schools = ids.map(id => Number(id));
      schoolIDs.value = ids.map(id => Number(id));
    };

    const getCourseTrackRouteIDs = (): void => {
      const ids = (route.query.courseTracks as string).split(",");
      currentFilter.value.courseTracks = ids.map(id => Number(id));
    };

    const checkSelectedBoxSchoolsByRouteIDS = (): void => {
      schools.value.forEach((school: School) => {
        currentFilter.value.schools.forEach(id => {
          if (school.id === id) {
            selectedSchoolBox.value.push(school);
          }
        });
      });
    };

    const checkSelectedBoxCourseTrackByRouteIDS = (): void => {
      courseTracks.value.forEach((courseTrack: CourseTrack) => {
        currentFilter.value.courseTracks
          .map(id => Number(id))
          .forEach(id => {
            if (courseTrack.id === id) {
              selectedCourseTracks.value.push(courseTrack);
            }
          });
      });
    };

    const isSchoolActive = (schoolID?: number): boolean => {
      if (schoolID) {
        return currentFilter.value.schools.includes(schoolID);
      } else {
        return false;
      }
    };

    const filterCourseTracksBySchools = async (): Promise<void> => {
      const updatedCourseTracks: CourseTrack[] = [];

      for (const schoolId of currentFilter.value.schools) {
        await loadCourseTracksOfSchool(schoolId);

        const courseTracks: CourseTrack[] =
          store.getters["categories_module/courseTracks"] || [];

        for (const courseTrack of courseTracks) {
          const alreadyExists = updatedCourseTracks.some(
            existingTrack => existingTrack.id === courseTrack.id
          );

          if (!alreadyExists) {
            updatedCourseTracks.push(courseTrack);
          }
        }
      }

      courseTracks.value = updatedCourseTracks;
    };

    const setSelectBoxVisibility = () => {
      if (window.matchMedia("(max-width:500px)").matches) {
        isSelectBoxVisible.value = true;
      }
    };

    const setWidthSelectedBoxCourseTrack = (): void => {
      if (window.matchMedia("(max-width:800px").matches) {
        widthSelectCourseTracks.value = "100%";
      }
    };

    const loadCourseTracksOfSchool = async (
      schoolID: number
    ): Promise<void> => {
      try {
        await wrapLoading(async () => {
          await store.dispatch(
            "categories_module/loadCourseTracksOfSchool",
            schoolID
          );
        });
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    };

    const filterBySchool = async (schoolID: number): Promise<void> => {
      try {
        await updateQuery(router, "page", "1");
        if (!schoolIDs.value.includes(schoolID)) {
          schoolIDs.value.push(schoolID);
          currentFilter.value.schools = schoolIDs.value;
        } else {
          const index = schoolIDs.value.indexOf(schoolID);
          if (index !== -1) {
            schoolIDs.value.splice(index, 1);
            currentFilter.value.schools = schoolIDs.value;
          }
          if (schoolIDs.value.length) {
            await loadCourseTracksOfSchool(schoolID);
            filteredCourseTracks.value =
              store.getters["categories_module/courseTracks"];
            filteredCourseTracks.value.forEach(
              (filteredCourseTrack: CourseTrack) => {
                courseTracks.value.push(filteredCourseTrack);
              }
            );
          } else {
            courseTracks.value = await store.dispatch(
              "categories_module/loadCourseTracks"
            );
          }
        }

        await updateQueries(router, { schools: String(schoolIDs.value) });

        if (schoolIDs.value && schoolIDs.value.length <= 0) {
          await removeQuery(router, "schools");
          await loadCourseTracks();
        }
      } catch (e) {
        await dispatchError(e);
      }
    };

    const loadCourse = async (filter: FilterCourse): Promise<void> => {
      const order: Order = getOrderFromURL(route);

      try {
        await store.dispatch("course_module/loadCourses", {
          order,
          filter: filter
        });
      } catch (e) {
        await dispatchError(e);
      }
    };

    const loadCourseTracks = async (): Promise<void> => {
      try {
        await store.dispatch("categories_module/loadCourseTracks");
      } catch (e) {
        await dispatchError(e);
      }
    };

    /** Load all information based in user's status (if is logged) required to display in dashboard view */
    async function loadInformation(): Promise<void> {
      await loadUser();
      await loadIncompletePills(0);
      await loadUserInterests();
      await getMandatoryCourseTrack();
      await loadEvents();
      await loadInterests();
      await loadSchools();
    }

    const listMandatoryCourseTrackTraining = async (
      courseTrackID: number,
      index: number
    ): Promise<void> => {
      try {
        await store.dispatch("course_track_module/listCourseTrackTraining", {
          courseTrackID: courseTrackID,
          index
        });
      } catch (e) {
        await dispatchError(e);
      }
    };

    const listMandatoryCourseTrack = async (order: Order): Promise<void> => {
      try {
        order.filterType = 1;

        await store.dispatch(
          "course_track_module/getRequiredCourseTrack",
          order
        );
      } catch (e) {
        await dispatchError(e);
      }
    };

    const getMandatoryCourseTrack = async (): Promise<void> => {
      try {
        const order: Order = getOrderFromURL(route);
        await listMandatoryCourseTrack(order);

        if (!mandatoryCourseTrack.value) return;

        await listMandatoryCourseTrackTraining(
          mandatoryCourseTrack.value[0].id,
          0
        );
      } catch (e) {
        await dispatchError(e);
      }
    };

    async function loadUser() {
      try {
        await store.dispatch("userProfile_module/loadUser");
        const userToClone = await store.getters["userProfile_module/user"];
        user.value = cloneObject(userToClone) as User;
      } catch (e) {
        await dispatchError(e);
      }
    }

    async function loadInterests() {
      try {
        await store.dispatch("interest_module/loadInterests");
        interests.value = store.getters["interest_module/interests"];
      } catch (e) {
        await dispatchError(e);
      }
    }

    const loadIncompletePills = async (index: number) => {
      try {
        await wrapLoading(async () => {
          await store.dispatch("pill_module/list", {
            index: index
          });
        });
        pillList.value = store.getters["pill_module/pillList"];
      } catch (e) {
        await dispatchError(e);
      }
    };

    const handleSlidePill = async () => {
      if (!pillList.value.has_more) return;
      await loadIncompletePills(pillList.value.pills.length);
    };

    async function loadSchools() {
      try {
        await store.dispatch("categories_module/loadSchools");
      } catch (e) {
        await dispatchError(e);
      }
    }

    /** Function responsible for loading events.*/
    async function loadEvents() {
      try {
        await store.dispatch("event_module/list");
      } catch (e) {
        await dispatchError(e);
      }
    }

    async function playPill(index: number) {
      openPill.value = true;
      startPill.value = index;
      completedPills.value = [];
      const _completedPills: Pill[] = [];
      try {
        await wrapLoading(async () => {
          const storedPills = store.getters["pill_module/pillList"].pills;
          for (let incompletePill of incompletePills.value) {
            const pill = storedPills.find(
              (item: Pill) => item.id === incompletePill.id
            );
            pill.isWatched = incompletePill.isWatched;
            pill.id = incompletePill.id;
            _completedPills.push(pill);
          }

          completedPills.value = _completedPills;
          disableBodyOverflow();
        });
      } catch (e) {
        await dispatchError(e);
        openPill.value = false;
      }
    }

    async function closePill() {
      openPill.value = false;
      enableBodyOverflow();
      await wrapLoading(async () => {
        await loadUser();
      });
    }

    async function setStep(step: number) {
      await router.push({ name: "onboarding", params: { step: step } });
    }

    async function previousStep() {
      await router.push({
        name: "onboarding",
        params: { step: currentStep.value - 1 }
      });
    }

    /** Close onboarding box when user click in the close button. */
    const closeOnBoarding = async (): Promise<void> => {
      try {
        user.value.isFirstLogin = false;
        await store.dispatch(
          "authentication_module/finishOnBoarding",
          user.value
        );
        await store.dispatch("userProfile_module/redoOnBoarding", false);
        enableBodyOverflow();

        await router.push({
          name: "dashboard",
          query: { page: "1" }
        });
      } catch (e) {
        await dispatchError(e);
      }
    };

    async function finishOnBoarding() {
      try {
        await closeOnBoarding();
        await store.dispatch(
          "interest_module/relateInterestToUser",
          userInterests.value
        );
        await store.dispatch("userProfile_module/updateUser", user.value);
        await router.push({
          name: "dashboard",
          query: { page: "1" }
        });
      } catch (e) {
        await dispatchError(e);
      }
    }

    async function nextStep() {
      if (currentStep.value === steps.value) {
        await finishOnBoarding();
        return;
      }
      await router.push({
        name: "onboarding",
        params: { step: currentStep.value + 1 }
      });
    }

    watch(
      () => router.currentRoute.value.params.step,
      () => (currentStep.value = Number(router.currentRoute.value.params.step))
    );

    const updateUserInterests = event => {
      userInterests.value = event;
    };
    const updateUser = event => {
      user.value = event;
    };

    const openIntroductoryContent = (
      _introductoryContent: Content | null
    ): void => {
      if (!_introductoryContent) return;
      introductoryContent.value = _introductoryContent;
      openModalIntroductoryContent.value = true;
      disableBodyOverflow();
    };

    const closeModalIntroductoryContent = (): void => {
      openModalIntroductoryContent.value = false;
      enableBodyOverflow();
    };

    const isCommentsModalOpen: ComputedRef<boolean> = computed(
      () => store.getters["course_module/isCommentsModalOpen"]
    );

    /** Disable the body overflow to not let the user scroll the page behind some modal while is open. */
    const disableBodyOverflow = () => {
      document.body.style.overflow = "hidden";
    };

    /** Enable the body overflow to let the user scroll the page after close some modal. */
    const enableBodyOverflow = () => {
      document.body.style.overflow = "auto";
    };

    /** Dispatch an action to open the comment modal on screen. */
    const openCommentsModal = async () => {
      disableBodyOverflow();
      await store.dispatch("course_module/openCommentsModal");
    };

    /** Dispatch an action to open the comment modal on screen. */
    const closeCommentsModal = async () => {
      enableBodyOverflow();
      await store.dispatch("course_module/closeCommentsModal");
    };

    /** Dispatch an action to load the comments. */
    const loadContentCommentsById = async (id: number) => {
      const order = getOrderFromURL(route);

      await wrapLoading(async () => {
        await store.dispatch("course_module/loadContentCommentsById", {
          courseID: id,
          order: order
        });
      });
    };

    /** Is what will be the title of the comment modal. */
    const commentModalTitle = ref("");

    /** Display the modal with the comments about the course. */
    const loadCourseCommentsModal = async (course: Course) => {
      try {
        commentModalTitle.value = course.title;
        await updateQueries(router, {
          pageDefault: "1",
          courseID: course.id.toString()
        });
        await openCommentsModal();
      } catch (e) {
        await dispatchError(e);
      }
    };

    /** Dispatch an action to load the comments. */
    const loadEventCommentsById = async (eventBasedOnClass: EventCourse) =>
      await store.dispatch(
        "course_module/loadEventCommentsById",
        eventBasedOnClass.id
      );

    /** Display the modal with the comments about the event. */
    const loadEventCommentsModal = async (eventCourse: EventCourse) => {
      try {
        commentModalTitle.value = eventCourse.name;
        await openCommentsModal();
        await loadEventCommentsById(eventCourse);
      } catch (e) {
        await dispatchError(e);
      }
    };

    const comments: ComputedRef<ContentComment[]> = computed(
      () => store.getters["course_module/comments"]
    );

    const isPillsCentered = ref(false);

    /** Center pills carousel if there's less than the maximum number
     * of pills that fit in the current screen size. */
    const setPillsCarouselJustifyContent = (): void => {
      if (!incompletePills.value) return;
      if (
        document.body.offsetWidth > 1060 &&
        incompletePills.value.length <= 10
      ) {
        isPillsCentered.value = true;
        return;
      }

      if (
        document.body.offsetWidth > 960 &&
        incompletePills.value.length <= 8
      ) {
        isPillsCentered.value = true;
        return;
      }

      if (
        document.body.offsetWidth > 860 &&
        incompletePills.value.length <= 7
      ) {
        isPillsCentered.value = true;
        return;
      }

      if (
        document.body.offsetWidth > 740 &&
        incompletePills.value.length <= 6
      ) {
        isPillsCentered.value = true;
        return;
      }

      if (
        document.body.offsetWidth > 740 &&
        incompletePills.value.length <= 6
      ) {
        isPillsCentered.value = true;
        return;
      }

      if (
        document.body.offsetWidth > 620 &&
        incompletePills.value.length <= 5
      ) {
        isPillsCentered.value = true;
        return;
      }

      if (
        document.body.offsetWidth > 515 &&
        incompletePills.value.length <= 4
      ) {
        isPillsCentered.value = true;
        return;
      }

      if (
        document.body.offsetWidth > 390 &&
        incompletePills.value.length <= 3
      ) {
        isPillsCentered.value = true;
        return;
      }

      if (
        document.body.offsetWidth > 280 &&
        incompletePills.value.length <= 2
      ) {
        isPillsCentered.value = true;
        return;
      }

      isPillsCentered.value = false;
    };

    /** Hides arrow buttons of the event carousel if there's no need for it. */
    const setEventCarouselButtonVisibility = async () => {
      const events = await eventCourses.value;
      const hasLessThanMaxVisibleEvents = events.length < 6;
      const isBigScreen = document.body.offsetWidth > 1060;
      if (hasLessThanMaxVisibleEvents && isBigScreen) {
        eventInFocusIndex.value = undefined;
      } else if (!isBigScreen) {
        eventInFocusIndex.value = 0;
      }
    };

    const onResize = async () => {
      pillInFocusIndex.value = 0;
      await setEventCarouselButtonVisibility();
      setPillsCarouselJustifyContent();
    };

    window.addEventListener("resize", onResize);

    async function loadUserInterests(): Promise<void> {
      try {
        await store.dispatch("interest_module/getUserInterests");
      } catch (e) {
        await dispatchError(e);
      }
    }
    return {
      openPill,
      pillSettings,
      pillInFocusIndex,
      pillBreakpoints,
      eventsSettings,
      eventInFocusIndex,
      eventsBreakpoints,
      recommendedSettings,
      recommendedBreakpoints,
      user,
      interests,
      userInterests,
      redoingOnBoarding,
      incompletePills,
      completedPills,
      isPillsCentered,
      startPill,
      schools,
      steps,
      currentStep,
      messages,
      eventCourses,
      courses,
      coursesPages,
      courseTracks,
      schoolFilterIsActive,
      currentFilter,
      courseTracksBySchool,
      selectedCourseTracks,
      schoolIDs,
      selectedSchoolBox,
      isSelectBoxVisible,
      showPills,
      widthSelectCourseTracks,
      openModalIntroductoryContent,
      comments,
      commentModalTitle,
      isCommentsModalOpen,
      coursesInProgress,
      ongoingCourseSettings,
      ongoingCourseBreakpoints,
      newCourseBreakpoints,
      newCourseSettings,
      newsCourses,
      userInformation,
      introductoryContent,
      isInfoPanelVisible,
      mandatoryCourseTrackTrainings,
      mandatoryCourseTrack,
      searchTraining,
      handleSlidePill,
      handleSlideCoursesInProgress,
      toggleInfoPanel,
      isSchoolActive,
      closeOnBoarding,
      finishOnBoarding,
      updateUser,
      updateUserInterests,
      playPill,
      closePill,
      setStep,
      previousStep,
      nextStep,
      filterBySchool,
      loadCourse,
      closeModalIntroductoryContent,
      openIntroductoryContent,
      loadCourseCommentsModal,
      loadEventCommentsModal,
      closeCommentsModal,
      toLocaleDateTime,
      showOnboarding,
      isDecolaTemplate,
      updateQuery,
      fetchInformations,
      informationsExist
    };
  }
};
